import {
    getAllUsersWithPagination,
    getFilteredUserCount,
} from "services/requests/v1/user";

import {
    SetRequestError,
    SetStateType,
    UnsubscribeContentType,
} from "types/generic";

import CustomStore from "devextreme/data/custom_store";
import moment from "moment-timezone";

import "moment-timezone";
import { IntlShape } from "react-intl";

type MakeUsersPageTabFunctionsType = {
    dateFormatRef: React.MutableRefObject<string | undefined>;
    textFilter: string;
    contentName: string;
    intl: IntlShape;
    setDatasource: SetStateType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
};

export const makeUsersPageTabFunctions = ({
    dateFormatRef,
    textFilter,
    contentName,
    intl,
    setDatasource,
    unsubscribeContent,
    setError,
}: MakeUsersPageTabFunctionsType) => {
    const dateParsedToLocale = (date: any) => {
        return moment(date.value).format(dateFormatRef.current);
    };

    const defaultValueFormatter = (params: any) => {
        if (params.value && params.value !== "") {
            return params.value;
        } else {
            return "-";
        }
    };

    const createDatasource = async () => {
        let textFilterAux: string | null = null;
        let skipAux: number | null = null;
        let dataSourceAux = {};

        const newDatasource = new CustomStore({
            key: "ID",
            load: async (loadOptions: any) => {
                if (
                    textFilterAux !== textFilter ||
                    skipAux !== loadOptions.skip
                ) {
                    textFilterAux = textFilter;
                    skipAux = loadOptions.skip;

                    try {
                        const users = await getAllUsersWithPagination(
                            loadOptions.take,
                            loadOptions.skip,
                            textFilter
                        );
                        const totalCount = await getFilteredUserCount(
                            textFilter
                        );
                        dataSourceAux = {
                            data: users.data,
                            totalCount: totalCount.data,
                        };

                        unsubscribeContent(contentName);

                        return {
                            data: users.data,
                            totalCount: totalCount.data,
                        };
                    } catch (error) {
                        setError(contentName);
                    }
                }
                return dataSourceAux;
            },
        });
        setDatasource(newDatasource);
    };

    const renderStatusLabel = (params: any) => {
        if (params.value !== undefined) {
            return (
                <div
                    className={
                        "c-user-table-status " +
                        (params.value ? "--enabled" : "--disabled")
                    }
                >
                    {params.value
                        ? intl.formatMessage({ id: "app.users.enabled" })
                        : intl.formatMessage({ id: "app.users.disabled" })}
                </div>
            );
        } else {
            return <></>;
        }
    };

    return {
        dateParsedToLocale,
        defaultValueFormatter,
        createDatasource,
        renderStatusLabel,
    };
};
